import { ArrowRight, Check, MapPin, PackageCheck, ShieldCheck } from "lucide-react";

const steps = [
  { number: "01", icon: MapPin, title: "SOURCE TRACE", copy: "We work through vetted manufacturing partners and keep origin, lead time, and maker information visible before dispatch." },
  { number: "02", icon: ShieldCheck, title: "FIELD VERIFY", copy: "Every listed unit carries the durability signal, essential specs, and return path that matter after the unboxing." },
  { number: "03", icon: PackageCheck, title: "DISPATCH CLEAR", copy: "Shipping and returns follow the product maker's route, with the right instructions attached to every order." },
];

export default function SupplyChainNote() {
  return (
    <section className="supply-section section-shell" data-testid="supply-chain-note">
      <div className="supply-heading"><p className="eyebrow">03 / SOURCE TO DISPATCH</p><h2>Know where it starts.<br /><em>Know what comes next.</em></h2></div>
      <div className="supply-grid">{steps.map(({ number, icon: Icon, title, copy }) => <article className="supply-step" key={number}><span className="chapter-number">{number}</span><Icon size={20} strokeWidth={1.3} /><h3>{title}</h3><p>{copy}</p><ArrowRight className="step-arrow" size={18} /></article>)}</div>
      <div className="supply-footer"><Check size={15} /> <span>ORIGIN, DELIVERY WINDOW, AND RETURN ROUTE ARE PART OF THE BRIEF — NOT FINE PRINT.</span></div>
    </section>
  );
}
